$(function () {
  if (!customElements.get('products-recommend')) {
    customElements.define(
      'products-recommend',
      class ProductsRecommend extends HTMLElement {
        constructor() {
          super();
          this.recommendContainer = null;
          this.observer = null;
          this.handleIntersection = this.handleIntersection.bind(this);
        }

        connectedCallback() {
          this.recommendContainer = this.querySelector('.product-recommendations');

          if (!this.recommendContainer) return;

          // 配置 IntersectionObserver
          this.observer = new IntersectionObserver(this.handleIntersection, {
            rootMargin: '0px 0px 200px 0px',
          });

          this.observer.observe(this.recommendContainer);
        }

        disconnectedCallback() {
          if (this.observer) {
            this.observer.disconnect();
          }
        }

        async handleIntersection(entries) {
          const entry = entries[0];
          if (!entry.isIntersecting) return;

          // 停止观察目标元素
          this.observer.unobserve(entry.target);

          try {
            const response = await fetch(entry.target.dataset.url);
            const text = await response.text();
            console.log('text111222', response);
            const parser = new DOMParser();
            const doc = parser.parseFromString(text, 'text/html');
            const recommendations = doc.querySelector('.product-recommendations');

            if (recommendations?.innerHTML.trim()) {
              this.recommendContainer.innerHTML = recommendations.innerHTML;

              // 触发自定义事件通知外部
              this.dispatchEvent(
                new CustomEvent('recommendations-loaded', {
                  bubbles: true,
                  detail: { container: this.recommendContainer },
                })
              );
            }
          } catch (error) {
            console.error('Failed to load recommendations:', error);
            this.dispatchEvent(
              new CustomEvent('recommendations-error', {
                bubbles: true,
                detail: { error },
              })
            );
          }
        }
      }
    );
  }
});
